var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ReactComponent as BackgroundCircles } from '@backrs_ui/common-ui/src/assets/images/background-circles.svg';
import { Box, Dialog } from '@mui/material';
import { AppIcon } from '../designSystem/icons/AppIcon';
import { FeaturedIcon } from '../designSystem/icons/FeaturedIcon';
export var InfoView = function (_a) {
    var onClose = _a.onClose, headerContent = _a.headerContent, bodyContent = _a.bodyContent, _b = _a.icon, icon = _b === void 0 ? 'InfoCircle' : _b;
    return (_jsxs(Box, { sx: containerSx, children: [_jsxs(Box, { sx: headerSx(!!headerContent), children: [!!headerContent && (_jsx(Box, { sx: backgroundCirclesSx, children: _jsx(BackgroundCircles, {}) })), _jsxs(Box, { sx: iconsSx(!!headerContent), children: [!!headerContent && (_jsx(FeaturedIcon, { iconName: icon, size: "lg", color: "Colors/Foreground/fg-secondary" })), onClose && (_jsx(Box, { sx: closeIconSx(!!headerContent), onClick: onClose, children: _jsx(AppIcon, { iconName: "XClose", diameter: "20px", color: "Colors/Foreground/fg-quaternary" }) }))] }), headerContent] }), _jsx(Box, { children: bodyContent })] }));
};
export var InfoModal = function (_a) {
    var open = _a.open, onClose = _a.onClose, _b = _a.width, width = _b === void 0 ? 'md' : _b, headerContent = _a.headerContent, bodyContent = _a.bodyContent, dialogSx = _a.dialogSx, icon = _a.icon;
    return (_jsx(Dialog, { className: "info-modal-dialog", open: open, onClose: onClose, sx: [dialogStyle, dialogSx].filter(Boolean), maxWidth: width, fullWidth: true, children: _jsx(InfoView, { onClose: onClose, headerContent: headerContent, bodyContent: bodyContent, icon: icon }) }));
};
var containerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        p: backrs.spacing['spacing-3xl'],
        overflow: 'hidden',
        overflowY: 'auto',
    });
};
var headerSx = function (hasHeaderContent) {
    return function (_a) {
        var backrs = _a.backrs;
        return (__assign({ position: 'relative', width: '100%' }, (hasHeaderContent && {
            mb: backrs.spacing['spacing-2xl'],
        })));
    };
};
var iconsSx = function (hasHeaderContent) {
    return function (_a) {
        var backrs = _a.backrs;
        return (__assign({ zIndex: 0, display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }, (hasHeaderContent && {
            mb: backrs.spacing['spacing-xl'],
            justifyContent: 'space-between',
        })));
    };
};
var closeIconSx = function (hasHeaderContent) {
    return function () { return (__assign({ cursor: 'pointer', justifySelf: 'flex-end' }, (!hasHeaderContent && {
        position: 'absolute',
        top: 0,
        right: 0,
        zIndex: 1000,
    }))); };
};
var backgroundCirclesSx = {
    position: 'absolute',
    top: -(336 * 0.425),
    left: -(336 * 0.425),
    zIndex: 1,
};
var dialogStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        zIndex: 99999,
        '& .MuiDialog-paper': {
            borderRadius: backrs.radius['radius-xl'],
            boxShadow: backrs.shadows['shadow-xl'],
            border: "1px solid ".concat(backrs.colors['Colors/Base/Black']),
        },
    });
};
